<template>
  <div class="scroll-progress" id="scrollProgress"></div>
</template>
